export interface AlertType {
  symbol: string;
  alert_condition: string;
  price: number;
  notes: string;
  id: number;
  exchangeKeyId: number;
  exchange_key_id?: number;
}

export enum AlertTriggers {
  LESS_THAN = "Price drops to",
  MORE_THAN = "Price reaches",
}
